export default __webpack_public_path__ + "static/media/1853.518f9353.png";